import { useIsFetching, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

import { getDiscount } from "@/api";
import { useSessionExpiredStore } from "@/stores/useSessionExpiredStore";

export function useDiscount() {
  const isLoginFetching = useIsFetching({ queryKey: ["login"] });
  return useQuery({
    queryKey: ["discount"],
    queryFn: async () => {
      const { response, data, error } = await getDiscount();

      if (response.status === 403) {
        useSessionExpiredStore().setSessionExpired(true);
      }

      if (error) {
        throw error;
      }

      return data;
    },
    enabled: computed(() => isLoginFetching.value === 0),
  });
}
